const config = {backend: 'https://backend.ap.cancilico.site', localhost: 'https://ap.cancilico.site/', wsBackend: 'wss://backend.ap.cancilico.site', publicRoot: '/', labelSet: 4};
export default config;
